module.exports = __webpack_public_path__ + "img/image145.2970e745.png";